import * as React from "react";
import PropTypes from 'prop-types';

const SvgNoImage = props => {
  if (props.id !== "_svgnoimage") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 102 102" {...props}><path d="M58.125 21.875c2.793 0 5.715 1.914 6.907 4.512l.202.495 1.453 4.022c.444 1.228 1.947 2.286 3.27 2.454l.356.023h11.25c3.078 0 5.678 2.51 5.919 5.604l.018.468v32.6c0 3.148-2.454 5.807-5.48 6.053l-.457.019H18.124c-3.079 0-5.395-2.51-5.609-5.604l-.016-.468v-32.6c0-3.148 2.17-5.808 5.17-6.054l.455-.018H30c1.243 0 2.563-.945 3.083-2.123l.122-.326 1.172-3.881c.84-2.778 3.539-4.926 6.372-5.156l.501-.02h16.875zM50 34.375c-11.218 0-20.313 9.094-20.313 20.313C29.688 65.906 38.782 75 50 75c11.218 0 20.313-9.094 20.313-20.313 0-11.218-9.095-20.312-20.313-20.312zm0 3.125c9.477 0 17.188 7.71 17.188 17.188 0 9.477-7.71 17.187-17.188 17.187-9.477 0-17.188-7.71-17.188-17.188C32.813 45.21 40.523 37.5 50 37.5zm0 23.438a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25zm3.125-18.75h-6.25v15.624h6.25V42.188z" /></svg>;
};

SvgNoImage.displayName = "_svgnoimage";
SvgNoImage.propTypes = {
  id: PropTypes.string
};
SvgNoImage.defaultProps = {
  id: ''
};
export default SvgNoImage;